import { PanTopLeftIcon } from './PanTopLeftIcon';

/**
 * author: Simran
 * id C497D005-A9A3-4B1A-B440-CE574E81AF2F
 * name pan-top-left
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-top-left.svg
 * tags
 */
export const PanUpLeftIcon = PanTopLeftIcon;
export default PanUpLeftIcon